export default function passwordValidation(val) {
  const lowercase = val.match(/[a-z]+/g);
  const uppercase = val.match(/[A-Z]+/g);
  const digits = val.match(/[\d]+/g);
  const special = val.match(/[!@#$%^&*_.]+/g);
  const length = val.match(/^.{6,32}$/);
  if(!val) return "Please type your password"
  if (lowercase === null) {
    return "Password must include at least one lowercase letter";
  }
  if (uppercase === null) {
    return "Password must include at least one uppercase letter";
  }
  if (digits === null) {
    return "Password must include at least one digit from 0 to 9";
  }
  if (special === null) {
    return "Password must include at least one special character";
  }
  if (length === null) {
    return "Password must be between 6 and 32 characters long";
  }
}
